import React from "react";

interface ArticleLayoutProps {
  toc: React.ReactNode;
  children: React.ReactNode;
}

export default function ArticleLayout({ toc, children }: ArticleLayoutProps) {
  return (
    /* `article-section` trims the global 96px top padding: the hero, its addon
       and the sticky bar already separate this block from what precedes it. */
    <section className="section article-section">
      <div className="container container-tight">
        <div className="article">
          {toc}
          <div>{children}</div>
        </div>
      </div>
    </section>
  );
}
